<template>
  <section class="credits-get-credit  container">
    <div class="credits-get-credit__content  container-inner">
      <picture class="credits-get-credit__img">
        <source v-if="section.image_webp"
                :srcset="section.image_webp"
                type="image/webp">
        <img :src="section.image"
             :alt="createAltMixin('')"
             :title="createTitleMixin('')">
      </picture>
      <div class="credits-get-credit__text-wrap">
        <div v-html="section.text"
             class="credits-get-credit__text text"></div>
        <CreditsPageAdvantagesBtn class="credits-get-credit__btn"/>
      </div>
    </div>
  </section>
</template>

<script>
  import CreditsPageAdvantagesBtn from './common/CreditsPageAdvantagesBtn'

  export default {
    name: 'CreditsPageGetCredit',
    components: {
      CreditsPageAdvantagesBtn
    },
    props: {
      section: Object
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>